
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
import { useEffect } from '@storybook/client-api';
import { createElasticTextArea } from '../../components/input/elastic-textarea.ts';
import './demo/demo.scss';
import {
  forDemoPurposesOnlyText,
  runProposedInlineJS,
} from './js/draft-email-textarea.js';
import prototypeDemo from './demo/demo.twig';
const prototypeData = {
  draftSubject: 'Discuss potential project',
  draftMessage: forDemoPurposesOnlyText,
};


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Prototypes/Draft Email" parameters={{
      docs: {
        page: null
      },
      layout: 'fullscreen'
    }} decorators={[story => {
      useEffect(() => {
        const {
          destroy: destroyDraftEmail
        } = runProposedInlineJS();
        const {
          destroy: destroyElasticTextArea
        } = createElasticTextArea(document.querySelector('.js-elastic-textarea'));
        return () => {
          destroyDraftEmail();
          destroyElasticTextArea();
        };
      }, []);
      return story();
    }]} mdxType="Meta" />
    <h1>{`Draft Email Prototype Demo`}</h1>
    <p>{`The HTML markup, CSS, and JavaScript logic will be included as a Gutenberg Custom HTML block in WordPress for this unique use case.`}</p>
    <p>{`For full demo functionality, open the "Canvas" view in a new tab.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Demo" args={prototypeData} mdxType="Story">
    {args => prototypeDemo(args)}
  </Story>
    </Canvas>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const demo = (args => prototypeDemo(args));
demo.storyName = 'Demo';
demo.args = prototypeData;
demo.parameters = { storySource: { source: 'args => prototypeDemo(args)' } };

const componentMeta = { title: 'Prototypes/Draft Email', parameters: {
  docs: {
    page: null
  },
  layout: 'fullscreen'
}, decorators: [story => {
  useEffect(() => {
    const {
      destroy: destroyDraftEmail
    } = runProposedInlineJS();
    const {
      destroy: destroyElasticTextArea
    } = createElasticTextArea(document.querySelector('.js-elastic-textarea'));
    return () => {
      destroyDraftEmail();
      destroyElasticTextArea();
    };
  }, []);
  return story();
}], includeStories: ["demo"],  };

const mdxStoryNameToKey = {"Demo":"demo"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;